// Mock data for Arteğitim Danışmanlık website

export const services = [
  {
    id: 1,
    title: "Dil Kursu",
    description: "Çekya'da dil öğrenmek, kültürel adaptasyon için en önemli adımdır. Size en uygun dil kursunu bulmak için yanınızdayız.",
    icon: "Languages",
    features: [
      "Yoğun Çekçe kursları",
      "Online ve yüz yüze seçenekler",
      "Sertifika programları",
      "Uygun fiyatlandırma"
    ],
    image: "https://images.unsplash.com/photo-1583373834259-46cc92173cb7"
  },
  {
    id: 2,
    title: "Lisans Programları",
    description: "Çekya'nın prestijli üniversitelerinde lisans eğitimi alma fırsatı. Burslar ve başvuru sürecinde tam destek.",
    icon: "GraduationCap",
    features: [
      "Üniversite seçimi danışmanlığı",
      "Başvuru dosyası hazırlama",
      "Burs imkanları",
      "Vize süreçleri"
    ],
    image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6"
  },
  {
    id: 3,
    title: "Yüksek Lisans",
    description: "Kariyer hedeflerinize uygun master programları ve akademik başarınız için profesyonel rehberlik.",
    icon: "BookOpen",
    features: [
      "Program seçimi danışmanlığı",
      "Motivasyon mektubu hazırlama",
      "Referans mektubu desteği",
      "Akademik CV hazırlama"
    ],
    image: "https://images.unsplash.com/photo-1590579491624-f98f36d4c763"
  }
];

export const universities = [
  {
    id: 1,
    name: "Charles Üniversitesi",
    city: "Prag",
    founded: 1348,
    description: "Orta Avrupa'nın en eski üniversitesi. Dünya sıralamasında üst sıralarda yer alan prestijli bir eğitim kurumu.",
    programs: ["Tıp", "Hukuk", "Sosyal Bilimler", "Fen Bilimleri"],
    image: "https://images.unsplash.com/photo-1613002928486-12d93bd86e1a",
    ranking: "QS World Ranking: 248"
  },
  {
    id: 2,
    name: "Çek Teknik Üniversitesi",
    city: "Prag",
    founded: 1707,
    description: "Mühendislik ve teknik bilimler alanında Avrupa'nın önde gelen üniversitelerinden biri.",
    programs: ["Mühendislik", "Mimarlık", "Bilgisayar Bilimleri", "Matematik", "Pilotluk"],
    image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6",
    ranking: "QS World Ranking: 430"
  },
  {
    id: 3,
    name: "Masaryk Üniversitesi",
    city: "Brno",
    founded: 1919,
    description: "Çekya'nın ikinci büyük şehrinde, modern eğitim anlayışıyla öne çıkan kapsamlı üniversite.",
    programs: ["Tıp", "Ekonomi", "Psikoloji", "Bilgi Teknolojileri"],
    image: "https://images.unsplash.com/photo-1583373834259-46cc92173cb7",
    ranking: "QS World Ranking: 551-560"
  },
  {
    id: 4,
    name: "Prag Ekonomi Üniversitesi",
    city: "Prag",
    founded: 1953,
    description: "Ekonomi, işletme ve finans alanlarında uzmanlaşmış en iyi üniversitelerden.",
    programs: ["İşletme", "Ekonomi", "Finans", "Uluslararası İlişkiler"],
    image: "https://images.unsplash.com/photo-1590579491624-f98f36d4c763",
    ranking: "Bölgesel Lider"
  },
  {
    id: 5,
    name: "Anglo-Amerikan Üniversitesi",
    city: "Prag",
    founded: 1990,
    description: "İngilizce eğitim veren, liberal arts geleneğine sahip özel üniversite. Uluslararası öğrenciler için ideal.",
    programs: ["Uluslararası İlişkiler", "İşletme", "Gazetecilik", "İnsan Hakları"],
    image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6",
    ranking: "Özel Üniversite - Lider"
  },
  {
    id: 6,
    name: "Metropolitan Üniversitesi Prag",
    city: "Prag",
    founded: 2001,
    description: "Modern eğitim yaklaşımıyla öne çıkan, İngilizce programlar sunan dinamik özel üniversite.",
    programs: ["Uluslararası İlişkiler", "İşletme Yönetimi", "Medya İletişimi", "Psikoloji"],
    image: "https://images.unsplash.com/photo-1583373834259-46cc92173cb7",
    ranking: "Özel Üniversite"
  }
];

export const applicationSteps = [
  {
    id: 1,
    title: "İlk Görüşme",
    description: "Hedeflerinizi ve eğitim geçmişinizi değerlendiriyoruz. Size en uygun programları belirliyoruz.",
    icon: "MessageSquare",
    duration: "1 hafta"
  },
  {
    id: 2,
    title: "Üniversite Seçimi",
    description: "Kariyer hedeflerinize uygun üniversite ve programları birlikte seçiyoruz.",
    icon: "Search",
    duration: "1-2 hafta"
  },
  {
    id: 3,
    title: "Başvuru Hazırlığı",
    description: "Tüm belgelerinizi hazırlıyor, motivasyon mektubunuzu yazıyoruz.",
    icon: "FileText",
    duration: "2-3 hafta"
  },
  {
    id: 4,
    title: "Başvuru",
    description: "Başvurunuzu yapıyor ve süreci takip ediyoruz.",
    icon: "Send",
    duration: "1 hafta"
  },
  {
    id: 5,
    title: "Vize İşlemleri",
    description: "Kabul aldıktan sonra vize başvurunuzu hazırlıyor ve randevu alıyoruz.",
    icon: "Plane",
    duration: "3-4 hafta"
  },
  {
    id: 6,
    title: "Gidiş Hazırlığı",
    description: "Konaklama, havalimanı karşılama ve ilk yerleşim sürecinde yanınızdayız.",
    icon: "Home",
    duration: "2 hafta"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Zeynep Yılmaz",
    program: "Tıp - Charles Üniversitesi",
    year: 2023,
    comment: "Arteğitim sayesinde hayalim olan Charles Üniversitesi'nde tıp okuyorum. Başvuru sürecinde her adımda yanımda oldular. Çok teşekkür ederim!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846"
  },
  {
    id: 2,
    name: "Mehmet Kaya",
    program: "Bilgisayar Mühendisliği - Çek Teknik Üniversitesi",
    year: 2022,
    comment: "Profesyonel ve güvenilir bir danışmanlık hizmeti. Dil kursundan üniversite başvurusuna kadar her şeyde destek oldular.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31"
  },
  {
    id: 3,
    name: "Ayşe Demir",
    program: "İşletme Yönetimi - Prag Ekonomi Üniversitesi",
    year: 2023,
    comment: "Çekya'da okumak isteyenlere kesinlikle Arteğitim'i tavsiye ederim. Hem uygun fiyat hem de kaliteli hizmet.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1627556704353-016baeb12c79"
  },
  {
    id: 4,
    name: "Can Özkan",
    program: "Yüksek Lisans - Masaryk Üniversitesi",
    year: 2024,
    comment: "Master başvurumda çok yardımcı oldular. Motivasyon mektubum ve CV'm mükemmel hazırlandı. Kesinlikle başarılı bir ekip!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Çekya'da Öğrenci Olmak: İlk Ayda Neler Yapmalı?",
    excerpt: "Çekya'ya yeni gelen öğrenciler için pratik ipuçları ve yapılması gerekenler listesi.",
    date: "15 Mart 2024",
    author: "Arteğitim Ekibi",
    category: "Öğrenci Hayatı",
    image: "https://images.unsplash.com/photo-1663968473220-89486bb8e4d3",
    readTime: "5 dk"
  },
  {
    id: 2,
    title: "2024 Yılında Çekya'da En Popüler Üniversite Programları",
    excerpt: "Bu yıl en çok tercih edilen bölümler ve gelecek vaat eden kariyer alanları.",
    date: "10 Mart 2024",
    author: "Arteğitim Ekibi",
    category: "Eğitim",
    image: "https://images.unsplash.com/photo-1576495199011-eb94736d05d6",
    readTime: "7 dk"
  },
  {
    id: 3,
    title: "Çekçe Öğrenmenin En Etkili Yolları",
    excerpt: "Dil öğrenme sürecinizi hızlandıracak yöntemler ve kaynaklar.",
    date: "5 Mart 2024",
    author: "Arteğitim Ekibi",
    category: "Dil Eğitimi",
    image: "https://images.unsplash.com/photo-1531545514256-b1400bc00f31",
    readTime: "6 dk"
  },
  {
    id: 4,
    title: "Çekya Öğrenci Vizesi: Başvuru Süreci Rehberi",
    excerpt: "Vize başvurusunda dikkat edilmesi gereken noktalar ve gerekli belgeler.",
    date: "1 Mart 2024",
    author: "Arteğitim Ekibi",
    category: "Vize",
    image: "https://images.unsplash.com/photo-1583373834259-46cc92173cb7",
    readTime: "8 dk"
  }
];

export const stats = [
  {
    id: 1,
    number: "500+",
    label: "Başarılı Öğrenci",
    icon: "Users"
  },
  {
    id: 2,
    number: "15+",
    label: "Partner Üniversite",
    icon: "Building2"
  },
  {
    id: 3,
    number: "98%",
    label: "Başarı Oranı",
    icon: "Award"
  },
  {
    id: 4,
    number: "7",
    label: "Yıllık Deneyim",
    icon: "Calendar"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Çekya'da eğitim almak için Çekçe bilmek şart mı?",
    answer: "Çek dilinde programlar için Çekçe bilmek gereklidir. Ancak birçok üniversite İngilizce programlar da sunmaktadır. Çekçe öğrenmek isteyenler için dil kursları mevcuttur."
  },
  {
    id: 2,
    question: "Başvuru süreci ne kadar sürer?",
    answer: "Başvuru süreci ortalama 2-3 ay sürmektedir. Ancak bu süre, programa ve üniversiteye göre değişebilir. Biz tüm süreçte size rehberlik ederiz."
  },
  {
    id: 3,
    question: "Çekya'da eğitim ücretsiz mi?",
    answer: "Çek dilinde verilen lisans ve yüksek lisans programları devlet üniversitelerinde ücretsizdir. İngilizce programlar için ücretler bulunmaktadır."
  },
  {
    id: 4,
    question: "Öğrenci vizesi almak zor mu?",
    answer: "Doğru belgelerle ve profesyonel danışmanlık ile vize alma süreci oldukça kolaydır. Biz tüm belge hazırlığında ve randevu sürecinde size yardımcı oluruz."
  },
  {
    id: 5,
    question: "Çekya'da öğrenci olarak çalışabilir miyim?",
    answer: "Evet, öğrenci vizesi ile haftada belirli saatlerde part-time çalışma hakkınız vardır. Bu sayede hem deneyim kazanır hem de harçlığınızı çıkarabilirsiniz."
  }
];

export const dormitories = [
  {
    id: 1,
    name: "Bro-Koli Studentské Rezidence",
    location: "Prag - Çeşitli Lokasyonlar",
    type: "Özel Öğrenci Yurdu",
    description: "Modern ve konforlu öğrenci yurtları. Prag'ın farklı bölgelerinde lokasyonları mevcut. Tam donanımlı odalar ve sosyal alanlar.",
    features: [
      "Tam mobilyalı odalar",
      "Yüksek hızlı Wi-Fi",
      "Ortak mutfak ve oturma alanları",
      "24/7 güvenlik",
      "Spor salonu ve çamaşırhane",
      "Sosyal etkinlikler"
    ],
    priceRange: "10,000 - 15,000 CZK/ay",
    image: "https://images.unsplash.com/photo-1555854877-bab0e564b8d5",
    website: "bro-koli.cz"
  },
  {
    id: 2,
    name: "Study Republic",
    location: "Prag - Merkezi Konumlar",
    type: "Premium Öğrenci Yurdu",
    description: "Lüks ve modern öğrenci yaşamı. Prag'ın en merkezi noktalarında, yeni ve şık rezidanslar. Uluslararası öğrenci topluluğu.",
    features: [
      "Studio ve paylaşımlı apartmanlar",
      "Ultra hızlı internet",
      "Özel çalışma alanları",
      "Fitness merkezi",
      "Sosyal etkinlik programı",
      "24/7 resepsiyon ve destek",
      "Tüm faturalar dahil"
    ],
    priceRange: "12,000 - 18,000 CZK/ay",
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267",
    website: "study-republic.com"
  }
];